import { gql } from '@apollo/client'

import { genericArticleViewFragment } from './fragments/genericArticleEntity'

export const GET_GENERIC_ARTICLE = gql`
    query GetGenericArticle($guid: String!, $groupGuid: String) {
        entity(guid: $guid, incrementViewCount: true) {
            ${genericArticleViewFragment}
        }
    }
`

export const GET_VIEWER_RIGHTS = gql`
    query GetViewerRights($subtype: String!, $groupGuid: String!) {
        viewer {
            guid
            loggedIn
            user {
                guid
                name
                icon
            }
            canInsertMedia(subtype: $subtype)
            requiresCommentModeration(subtype: $subtype, groupGuid: $groupGuid)
        }
    }
`
